module.exports = __webpack_public_path__ + "img/Kartik.0b56b14f.jpeg";